import SettingsLayout from "../layout/SettingsLayout";
import {useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {
  getAutomateMessage,
  postAutomateMessage
} from "../../api/message/automate-messages.api";
import SettingsStepLayout from "../layout/SettingsStepLayout";
import MessageDefaultInfo from "../volatility-message/MessageDefaultInfo";
import MessageContentsSettings from "../volatility-message/content/setting/MessageContentsSettings";
import AutomateMessageCondition from "../form/automatemessage/AutomateMessageCondition";
import {collectMessageUrlErrors} from "../../libs/urlValidator";

const AutomateMessageEdit = () => {
  const tabs = ["기본 설정", "콘텐츠 작성하기", "발송 조건 설정"]
  const [query] = useSearchParams();
  const [tab, setTab] = useState(1);
  const [message, setMessage] = useState({
    type: "FI", messageData: { type: "FI" }
  })

  const id = query.get("id");
  const entrypointId = query.get("entrypointId");

  const handleConfirm = async () => {
    // 랜딩 URL 스킴 검증(프론트 1차). 스킴 누락 시 저장 차단(백엔드도 400 으로 재검증).
    const urlErrors = collectMessageUrlErrors(message.messageData);
    if (urlErrors.length > 0) return alert(urlErrors[0]);

    // 단일 암호를 선택했다면 반드시 4자리를 입력해야 저장(빈 암호 오류 상태 예방)
    if (message.passwordType === "SINGLE" && (!message.password || message.password.length < 4)) {
      return alert("단일 암호는 4자리 숫자로 입력해주세요.")
    }

    await postAutomateMessage(message)
    alert("수정 되었습니다.");
    window.location.href = "/automate-message" + (entrypointId ? "?entrypointId=" + entrypointId : "")
  }

  useEffect(() => {
    getAutomateMessage(id, entrypointId).then(({data}) => {
      data.messageData = data.messageData ?? { type: "FI" }
      setMessage(data)
    })
  }, [id, entrypointId]);

  const updateMessage = (key, value) => {
    const newMessage = { ...message }
    newMessage[key] = value
    setMessage(newMessage)
  }

  const updateMessageData = (key, value) => {
    const newMessage = { ...message }
    const messageData = newMessage.messageData ?? {}
    messageData[key] = value
    newMessage.messageData = messageData
    setMessage(newMessage)
  }

  const updateMessageDataArrays = (arrayKeys, value) => {
    const newMessage = { ...message }
    const messageData = newMessage.messageData ?? {}

    let currentLevel = messageData;
    arrayKeys.forEach((arrayKey, idx) => {
      const isIndex = !isNaN(Number(arrayKeys[idx + 1]))
      currentLevel[arrayKey] = currentLevel[arrayKey] ?? (isIndex ? [] : {})

      if (idx < arrayKeys.length - 1) {
        currentLevel = currentLevel[arrayKey]
      } else {
        currentLevel[arrayKey] = value
      }
    })
    newMessage.messageData = messageData
    setMessage(newMessage)
  }

  const deleteMessageDataArrays = (index, arrayKeys) => {
    const newMessage = { ...message }
    const messageData = newMessage.messageData ?? {}
    messageData[arrayKeys] = messageData[arrayKeys] ?? []
    messageData[arrayKeys] = messageData[arrayKeys].filter((_, i) => i !== index)
    newMessage.messageData = messageData
    setMessage(newMessage)
  }

  const render = () => {
    const messageData = message.messageData ?? {}
    const type = messageData.type === "FT" ? "FI" : messageData.type

    if (tab === 1) {
      return (
          <div className="setting-step-padding">
            <MessageDefaultInfo campaignName={message?.name}
                                type={type}
                                onChangeCampaignName={(name) => {
                                  updateMessage("name", name)
                                }}
                                onChangeMessageType={(type) => {
                                  updateMessageData("type", type)
                                }}
            />
          </div>
      );
    } else if (tab === 2) {
      return (
          <MessageContentsSettings type={type}
                                   isConnect={true}
                                   isAuto={true}
                                   couponTitle="이벤트 참여 무료 쿠폰"
                                   messageData={messageData}
                                   onChangeMessageData={(key, value) => updateMessageData(key, value)}
                                   onChangeMessageDataArrays={(arrayKeys, value) => updateMessageDataArrays(arrayKeys, value)}
                                   onChangeImage={(key, imgUrl) => {
                                     const newMessage = { ...message }
                                     const messageData = newMessage.messageData ?? {}
                                       messageData["type"] = imgUrl === undefined ? "FT" : "FI"
                                     if (!messageData.image) {
                                       messageData["image"] = {}
                                     }
                                     messageData["image"][key] = imgUrl
                                     newMessage.messageData = messageData
                                     setMessage(newMessage)
                                   }}
                                   onDeleteMessageDataArrays={(index, arrayKeys) => deleteMessageDataArrays(index, arrayKeys)}
          />
      );
    } else if (tab === 3) {
      return (
          <AutomateMessageCondition
              automateMessage={message}
              setAutomateMessage={setMessage}
          />
      );
    }
  }

  return (
      <SettingsLayout
          title={"자동화 메시지"}
          tabs={tabs}
          activeTab={tab}
          onConfirm={handleConfirm}
          onChange={setTab}
          confirmText={"설정 완료"}
          onClose={() => window.location.href = "/automate-message"}
      >
        <SettingsStepLayout renderChild={render()} />
      </SettingsLayout>
  );
};
export default AutomateMessageEdit;
